import { useEffect, useRef, useState } from "react";

const STORAGE_KEY = "ask-studio-announcement-seen";

// Storage can be blocked or absent (private mode, some test runners): then
// the announcement simply shows, and shows again next time.
const hasSeen = () => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "true";
  } catch {
    return false;
  }
};
const remember = () => {
  try {
    window.localStorage.setItem(STORAGE_KEY, "true");
  } catch {
    // Nothing to do.
  }
};

/**
 * The one-time "Meet Sabine" announcement, anchored on the Ask button through
 * `targetRef`. Seen once, anywhere in the app, it never shows again.
 *
 * @returns {{ shouldShow: boolean, markAsSeen: () => void, targetRef: import("react").RefObject }}
 */
export function useAskStudioAnnouncement() {
  const [shouldShow, setShouldShow] = useState(false);
  const targetRef = useRef(null);

  useEffect(() => {
    if (hasSeen()) return undefined;
    // Let the page settle, then point at the button if it is on screen. The
    // strip stays mounted below `md` but hidden, so the button can exist with
    // no box; showing then would point at nothing and spend the one viewing.
    const timer = setTimeout(() => {
      if (targetRef.current?.getClientRects().length) setShouldShow(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const markAsSeen = () => {
    remember();
    setShouldShow(false);
  };

  return { shouldShow, markAsSeen, targetRef };
}
